import { createContext, useContext, useState, useEffect } from 'react'
import { trackPixelAddToCart } from '../utils/metaPixel'
import { logAddToCart } from '../firebase'

const CartContext = createContext()

export const useCart = () => useContext(CartContext)

const getEffectivePrice = (product) => {
  return product.discountPercent > 0 
    ? Math.round(product.price * (1 - product.discountPercent / 100))
    : product.price
}

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    const saved = localStorage.getItem('akhtar_sabir_cart')
    return saved ? JSON.parse(saved) : []
  })

  // Save cart to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('akhtar_sabir_cart', JSON.stringify(cart))
  }, [cart])

  const addToCart = (product, quantity = 1) => {
    setCart(prevCart => {
      const existingItem = prevCart.find(item => item.id === product.id)
      if (existingItem) {
        return prevCart.map(item =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + quantity }
            : item
        )
      }
      return [...prevCart, { ...product, quantity }]
    })
    const effectivePrice = getEffectivePrice(product)
    trackPixelAddToCart(product, quantity, effectivePrice)
    logAddToCart(product, quantity, effectivePrice)
  }

  const updateQuantity = (productId, quantity) => {
    if (quantity <= 0) {
      removeFromCart(productId)
      return
    }
    setCart(prevCart => 
      prevCart.map(item => 
        item.id === productId 
          ? { ...item, quantity }
          : item
      )
    )
  }

  const removeFromCart = (productId) => {
    setCart(prevCart => prevCart.filter(item => item.id !== productId))
  }

  const clearCart = () => {
    setCart([])
  }

  const cartTotal = cart.reduce((total, item) => total + (getEffectivePrice(item) * item.quantity), 0)
  const cartCount = cart.reduce((count, item) => count + item.quantity, 0)

  return (
    <CartContext.Provider value={{ 
      cart, 
      addToCart, 
      updateQuantity, 
      removeFromCart, 
      clearCart, 
      cartTotal, 
      cartCount 
    }}>
      {children}
    </CartContext.Provider>
  )
}
